import { merge } from 'lodash-es'
import { ArchiveStateConstant, ArchiveStateCore } from '../../types/mfc'
import { workerArchive } from '../actions/workerActions'
import { pubSubArchives } from './pubSub'

// const isArchivePage =
//     typeof window !== 'undefined' &&
//     document.location.pathname?.startsWith('/chat-archives')

// type URLArchiveParam = {
//     id?: string
// }

const defaultPrivateState = {
    username: null,
    isEmpty: false,
    dates: null,
    names: null,
    id: null,
}

export const ARCHIVESTATE: ArchiveStateConstant = {
    state: {
        private: { ...defaultPrivateState },
        showPrivateOnly: false,
        // initialized: false,
        id: null,
        public: {
            username: null,
            isEmpty: false,
            month: null,
            dates: null,
            names: null,
            year: null,
            loaded: {},
            index: {},
        },
    },
}

if (typeof window !== 'undefined') {
    window.__MFC_APP_MESSAGEARCHIVES__ = ARCHIVESTATE
}

export const resetArchiveState = (id = null) => {
    ARCHIVESTATE.state.showPrivateOnly = false
    ARCHIVESTATE.state.private = {
        ...defaultPrivateState,
    }

    ARCHIVESTATE.state.id = id

    ARCHIVESTATE.state.public.username = null
    ARCHIVESTATE.state.public.isEmpty = false
    ARCHIVESTATE.state.public.month = null
    ARCHIVESTATE.state.public.year = null

    if (!id) {
        registerYear()
        registerMonth()
    }

    pubSubArchives.emit('state', ARCHIVESTATE.state)
    pubSubArchives.emit('state::private', ARCHIVESTATE.state)
    pubSubArchives.emit('state::public', ARCHIVESTATE.state)
}

export const setShowPrivateOnlyState = (show) => {
    ARCHIVESTATE.state.showPrivateOnly = show

    if (show) {
        workerArchive({
            id: ARCHIVESTATE.state.id ?? null,
            isPrivateOnly: true,
        })
    }

    pubSubArchives.emit('state', ARCHIVESTATE.state)
}

const getCurrentMonthYear = () => {
    const date = new Date()

    date.setDate(1)

    const currentMonth = date.getMonth() + 1
    const currentYear = date.getFullYear()

    return { month: String(currentMonth), year: String(currentYear) }
}

export const setArchiveYearState = (year: string) => {
    ARCHIVESTATE.state.public.year = year

    const namespace = ARCHIVESTATE.state.id
        ? ARCHIVESTATE.state.public.username
        : 'list'

    const years = ARCHIVESTATE.state.public.index[namespace][year]

    const { year: currentYear, month: currentMonth } = getCurrentMonthYear()
    const isCurrentYear = year === currentYear

    if (!isCurrentYear && years && Object.keys(years).length) {
        registerMonth()
        pubSubArchives.emit('state::public', ARCHIVESTATE.state)
        return
    }

    ARCHIVESTATE.state.public.month = null

    workerArchive({
        month: isCurrentYear ? currentMonth : null,
        year: ARCHIVESTATE.state.public.year,
        id: ARCHIVESTATE.state.id,
    })

    pubSubArchives.emit('state::public', ARCHIVESTATE.state)
}

export const setArchiveMonthState = (month: string) => {
    const namespace = ARCHIVESTATE.state.id ?? 'list'

    ARCHIVESTATE.state.public.month = month

    const year = ARCHIVESTATE.state.public.year

    if (ARCHIVESTATE.state.public.loaded[namespace][year][month]) {
        pubSubArchives.emit('state::public', ARCHIVESTATE.state)
        return
    }

    workerArchive({
        year: ARCHIVESTATE.state.public.year,
        id: ARCHIVESTATE.state.id,
        month,
    })

    pubSubArchives.emit('state', ARCHIVESTATE.state)
}

const registerYear = () => {
    if (ARCHIVESTATE.state.id && !ARCHIVESTATE.state.public.username) {
        return
    }

    if (!ARCHIVESTATE.state.id && !ARCHIVESTATE.state.public.index?.list) {
        return
    }

    const years = Object.keys(
        ARCHIVESTATE.state.id
            ? ARCHIVESTATE.state.public.index[
                  ARCHIVESTATE.state.public.username
              ]
            : ARCHIVESTATE.state.public.index.list,
    )

    const year = years[years.length - 1]

    ARCHIVESTATE.state.public.year = year
}

const registerMonth = () => {
    if (ARCHIVESTATE.state.id && !ARCHIVESTATE.state.public.username) {
        return
    }

    if (!ARCHIVESTATE.state.id && !ARCHIVESTATE.state.public.index?.list) {
        return
    }

    const year = ARCHIVESTATE.state.public.year

    const months = Object.keys(
        ARCHIVESTATE.state.id
            ? ARCHIVESTATE.state.public.index[
                  ARCHIVESTATE.state.public.username
              ][year]
            : ARCHIVESTATE.state.public.index.list[year],
    )

    ARCHIVESTATE.state.public.month = months[months.length - 1]
}

const registerLoaded = (data) => {
    const { id = 'list', dates } = data

    const { month: currentMonth, year: currentYear } = getCurrentMonthYear()

    const years = Object.entries(dates)

    years.forEach(([year, months]) => {
        if (!ARCHIVESTATE.state.public.loaded[id]) {
            ARCHIVESTATE.state.public.loaded[id] = {}
        }

        if (!ARCHIVESTATE.state.public.loaded[id][year]) {
            ARCHIVESTATE.state.public.loaded[id][year] = {}
        }

        Object.keys(months).forEach((month) => {
            if (year === currentYear && month === currentMonth) {
                return
            }

            if (!ARCHIVESTATE.state.public.loaded[id][year][month]) {
                ARCHIVESTATE.state.public.loaded[id][year][month] = true
            }
        })
    })
}

export const mergeArchiveDataState = (data: Partial<ArchiveStateCore>) => {
    ARCHIVESTATE.state = merge({}, ARCHIVESTATE.state, data)

    if (data.private) {
        pubSubArchives.emit('state::private', ARCHIVESTATE.state)
        return
    }

    const {
        public: { isEmpty },
    } = data

    if (isEmpty) {
        ARCHIVESTATE.state.public.isEmpty = true
        pubSubArchives.emit('state::public', ARCHIVESTATE.state)
        return
    }

    if (data.public.dates) {
        registerLoaded(data.public)
    }

    if (!ARCHIVESTATE.state.public.year) {
        registerYear()
    }

    if (!ARCHIVESTATE.state.public.month) {
        registerMonth()
    }

    if (data.public) {
        pubSubArchives.emit('state::public', ARCHIVESTATE.state)
    }
}
